import axios from 'axios';
import { RequestHandler } from '../../app/RequestHandler';

export type Translations = Record<string, string>;

export async function getTranslations(): Promise<Translations> {
  const { language, country } = new RequestHandler();
  const url = `/eac/${language}_${country}/shock-absorber-backend/translationText`;

  const { data } = await axios.get<Translations>(url);

  return data;
}
